import { render, staticRenderFns } from "./SbBannerButton.vue?vue&type=template&id=3d212ae9&scoped=true"
import script from "./SbBannerButton.vue?vue&type=script&lang=js"
export * from "./SbBannerButton.vue?vue&type=script&lang=js"
import style0 from "./SbBannerButton.vue?vue&type=style&index=0&id=3d212ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d212ae9",
  null
  
)

export default component.exports